import * as eff from 'redux-saga/effects';
import createActionCreators from 'redux-resource-action-creators';
import {
  actionTypes,
} from '../actions';
import {
  throwError,
} from './helpers';
import api from '../api';
import { getIntentTask } from './utils';

export default function* productsFlow(reportChannel) {
  function* getProductOrPlan({
    qs,
    slug,
    resourceType,
    callbacks,
  }) {
    const actions = createActionCreators('read', {
      resourceType: resourceType || 'products',
      requestKey: 'getProductOrPlan',
    });

    yield eff.put(
      actions.pending(),
    );

    try {
      const product = yield eff.call(
        api.getProductOrPlanBySlug,
        {
          qs,
          slug,
          type: resourceType === 'productPlans' ? 'product_plans' : 'products',
        },
      );

      callbacks?.onSuccess?.(product);

      yield eff.put(actions.succeeded({
        resources: [product],
      }));
    } catch (e) {
      callbacks?.onError?.(e);

      yield eff.put(actions.failed({
        resources: [],
      }));

      yield eff.call(throwError, e);
    }
  }

  function* getProductPlans({ namespace, callbacks }) {
    const actions = createActionCreators('create', {
      resourceType: 'productPlans',
      requestKey: 'getProductPlans',
    });

    yield eff.put(
      actions.pending(),
    );

    try {
      const resources = yield eff.call(
        api.getProductPlansByNamespace,
        {
          qs: {
            namespace,
          },
        },
      );

      if (callbacks?.onSuccess) {
        callbacks.onSuccess(resources);
      }

      yield eff.put(actions.succeeded({
        resources,
      }));
    } catch (e) {
      if (callbacks?.onError) {
        callbacks.onError(e);
      }

      yield eff.put(actions.failed({
        resources: [],
      }));

      yield eff.call(throwError, e);
    }
  }

  function* buyProduct({ payload, callbacks }) {
    const actions = createActionCreators('create', {
      resourceType: 'paymentIntents',
      requestKey: 'buyProduct',
    });

    yield eff.put(actions.pending());

    try {
      const response = yield eff.call(
        api.createInvoice,
        {
          body: payload,
        },
      );

      const intent = yield eff.call(getIntentTask, response.id);

      callbacks?.onSuccess?.(intent);

      yield eff.put(actions.succeeded({
        resources: [intent],
      }));
    } catch (e) {
      callbacks?.onError?.(e);

      yield eff.put(actions.failed({
        resources: [],
      }));

      yield eff.call(throwError, e);
    }
  }

  function* finishBuy({
    reinitializeResources,
    paymentIntentId,
    callbacks,
  }) {
    const actions = createActionCreators('update', {
      resourceType: 'paymentIntents',
      requestKey: 'finishBuy',
    });

    yield eff.put(actions.pending());

    try {
      const response = yield eff.call(
        api.finishPaymentIntent,
        {
          id: paymentIntentId,
        },
      );

      yield eff.put(actions.succeeded({
        resources: [{
          id: paymentIntentId,
        }],
      }));

      if (reinitializeResources) {
        // Re-load resources
        yield eff.put(
          reportChannel,
          {
            messageType: 'reloadProfile',
          },
        );
      }

      callbacks?.onSuccess?.(response);
    } catch (e) {
      callbacks?.onError?.(e);

      yield eff.put(actions.failed({
        resources: [],
      }));

      yield eff.call(throwError, e);
    }
  }

  yield eff.takeEvery(actionTypes.REQUEST_PRODUCT_PLANS_BY_NAMESPACE, getProductPlans);
  yield eff.takeEvery(actionTypes.REQUEST_PRODUCT_OR_PLAN_BY_SLUG, getProductOrPlan);
  yield eff.takeEvery(actionTypes.REQUEST_FINISH_BUY, finishBuy);
  yield eff.takeEvery(actionTypes.REQUEST_BUY_PRODUCT, buyProduct);
}
